import { setTimeMetric as setTimeMetricDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    metric?: String,
}

export const setTimeMetric = ({
    metric,
    eventEmitter
}: Props) => {
    setTimeMetricDiagram(metric);
};

